import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/periods/1/2.jpg")